import React from "react";
import { PlatformOutcome, PlatformOffer, PlatformBetOfferType, SelectedOutcome } from "@freeplay/shared-code";
import { OutcomeOptionDisplay } from "./OutcomeOptionDisplay";
import { formatPositiveOddString } from "../picks/SelectionContainer";

export interface OutcomeOptionProps {
    testID?: string;
    gameOffer: PlatformOffer;
    betOutcomes?: SelectedOutcome[];
    resulted: boolean;
}

export const OutcomeOptions: React.FC<OutcomeOptionProps> = ({ gameOffer, betOutcomes = [], resulted, testID }) => {
    const oddsType = gameOffer.betOfferType;

    const getSelected = (outcome: PlatformOutcome) => {
        for (let i = 0; i < betOutcomes.length; ++i) {
            if (
                outcome.platformOffer === betOutcomes[i].platformOfferId &&
                outcome.id === betOutcomes[i].platformOutcomeId
            ) {
                return true;
            }
        }

        return false;
    };

    const getOddLabel = (outcome: PlatformOutcome) => {
        const odds = formatPositiveOddString(outcome.oddsAmerican);
        const spread = formatPositiveOddString((outcome.line / 1000).toString(10));
        const overUnder = (outcome.line / 1000).toString(10);

        if (oddsType === PlatformBetOfferType.HANDICAP) {
            return spread;
        }

        if (oddsType === PlatformBetOfferType.MATCH) {
            return odds;
        }

        if (oddsType === PlatformBetOfferType.OVERUNDER) {
            return overUnder;
        }
    };
    const getTitleLabel = (outcome: PlatformOutcome, index: number) => {
        if (oddsType === PlatformBetOfferType.HANDICAP || oddsType === PlatformBetOfferType.MATCH) {
            return outcome.participant;
        }

        if (oddsType === PlatformBetOfferType.OVERUNDER) {
            return index === 0 ? "OVER" : "UNDER";
        }
    };

    return (
        <>
            {gameOffer.platformOutcomes.map((outcome, index) => (
                <OutcomeOptionDisplay
                    key={`outcome-option-display-${index}`}
                    isWinner={outcome.isWinner}
                    selected={betOutcomes.length > 0 ? getSelected(outcome) : null}
                    topLabelText={`${getTitleLabel(outcome, index)}`}
                    bottomLabelText={`${getOddLabel(outcome)}`}
                    resulted={resulted}
                />
            ))}
        </>
    );
};
